import request from '@/utils/request'

export function getEpms5080DelyList(param) {
  let data = param
  return request({
    url: `/delivery/epms5080/getEpms5080DelyList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function getEpms5080PoList(param) {
  let data = param
  return request({
    url: `/delivery/epms5080/getEpms5080PoList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

export function epms5080InsDelivery(param) {
  let data = param
  return request({
    url: `/delivery/epms5080/epms5080InsDelivery`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}